import { useRef } from "react";
import Select, { ActionMeta, CSSObjectWithLabel } from "react-select";
import {
    adgroupChangeHandler,
    matchTypeChangeHandler,
    campaignChangeHandler,
} from "@ts/bulk-keywords-addition";
import makeAnimated from "react-select/animated";
import { IProps } from "@ts/common-types";

const animate = makeAnimated();

type Option = {
    value: number | string;
    label: string;
};

const BulkActionDropDown: React.FC<IProps> = (props) => {
    const valueRef = useRef(props.selectedOptions);
    valueRef.current = props.selectedOptions;

    const selectAllOption = { value: "*", label: "Select All" };
    const isSelectAllSelected = () => {
        if (props.options) {
            return valueRef.current.length === props.options.length;
        }
    };
    const isOptionSelected = (option: Option) =>
        valueRef.current.some(
            ({ value }: { value: string }) => value === option.value
        ) || isSelectAllSelected();

    const getValue = () =>
        isSelectAllSelected() ? [selectAllOption] : props.selectedOptions;

    const handleSelect = (
        newValue: unknown,
        actionMeta: ActionMeta<unknown>
    ) => {
        props.onChangeInSelectedOptions && props.onChangeInSelectedOptions();
        let newOptions;
        const { action, option, removedValue } = actionMeta;
        // Reassigning for typing. Unknown by default
        const opt = option as Option;
        const removed = removedValue as Option;
        if (action === "select-option" && opt.value === "*") {
            newOptions = props.options;
        } else if (
            (action === "deselect-option" && opt.value === "*") ||
            (action === "remove-value" && removed.value === "*")
        ) {
            newOptions = [];
        } else if (
            actionMeta.action === "deselect-option" &&
            isSelectAllSelected()
        ) {
            newOptions = props.options.filter(
                ({ value }: { value: string }) => value !== opt.value
            );
        } else {
            newOptions = newValue || [];
        }
        props.setSelectedOptions(newOptions);

        switch (props.id) {
            case "adgroup-list":
                adgroupChangeHandler(props);
                break;
            case "match-type-list":
                matchTypeChangeHandler(newOptions, props);
                break;
            case "campaign-list":
                campaignChangeHandler(newOptions, props);
                break;
            default:
                // Do Nothing
                break;
        }
        
    };

    return (
        <>
            <Select
                isOptionSelected={isOptionSelected}
                instanceId={props.id}
                id={props.id}
                closeMenuOnSelect={false}
                placeholder={props.placeholder}
                styles={{
                    container: (base: CSSObjectWithLabel) => ({
                        ...base,
                        maxWidth: "fit-content",
                        minWidth: "20vw",
                        marginBottom: "10px",
                    } as CSSObjectWithLabel),
                    placeholder: (base: CSSObjectWithLabel) => ({
                        ...base,
                        fontSize: "1rem",
                    } as CSSObjectWithLabel),
                }}
                defaultValue={props.options}
                value={getValue()}
                isMulti
                options={props.options}
                onChange={handleSelect}
                components={animate}
            />
        </>
    );
};

export default BulkActionDropDown;
